export function jqPagetop() {

    //////ページトップ
    $(function () {
        var topBtn = $('#pageTop');
        topBtn.hide();
        $(window).scroll(function () {
        if ($(this).scrollTop() > 650) {
            topBtn.fadeIn();
        } else {
            topBtn.fadeOut();
        }
        });
        topBtn.click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 550);
        return false;
        });
    });
}
